"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/es.object.to-string.js");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _vue2Editor = require("vue2-editor");
var _log = require("@/utils/log");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _cookie = require("@/utils/cookie");
var _resource = require("@/api/resource");
var _user = require("@/api/user");
var _utils = require("@/utils");
var _index = _interopRequireDefault(require("../../../../components/EventTime/index.vue"));
var _subscriptions = require("@/api/subscriptions");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var tmpLoopGeninfo = {};
var _default = exports.default = {
  name: 'LoopGeninfo',
  components: {
    VueEditor: _vue2Editor.VueEditor,
    EventTime: _index.default
  },
  props: {
    parentLoop: {
      type: Object,
      default: tmpLoopGeninfo
    },
    displayType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      dialogResourceVisible: false,
      dialogContactVisible: false,
      tableLoading: false,
      loopType: _lifehikesInitData.loopType,
      resourceQuery: {
        page: 1,
        limit: 999,
        q: undefined,
        type: undefined,
        sort: 'title'
      },
      contactQuery: {
        page: 1,
        limit: 999,
        q: undefined,
        sort: '-updatedAt'
      },
      resourceOptions: [],
      userList: [],
      customToolbar: [['bold'], [{
        list: 'bullet'
      }]],
      loading: false,
      timeZoneList: _lifehikesInitData.ianaTimeZone,
      countryList: [],
      tagInputVisible: false /* use for Tag component */,
      tagInputValue: '' /* use for tag component */,
      loop: {},
      loggedInUserTenants: [],
      subscriptionsList: [],
      subscriptionsLoading: false
    };
  },
  watch: {
    loop: {
      handler: function handler(newVal) {
        this.passBackGenInfo(newVal);
      },
      deep: true
    }
  },
  created: function created() {
    var _this = this;
    this.loop = this.parentLoop;
    this.fetchLoopSubscriptions();
    console.info('loop info');
    console.info(this.loop);
    // console.info(JSON.stringify(this.parentLoop));
    this.$store.dispatch('facets/getInitData', 'en').then(function () {
      _this.countryList = _this.$store.getters.countries;
    });
    if (this.$store.getters.userMetadata && this.$store.getters.userMetadata.tenants) {
      this.loggedInUserTenants = this.$store.getters.userMetadata.tenants;
    }
  },
  methods: {
    getTenantLabel: _utils.getTenantLabel,
    openSubscription: function openSubscription(id) {
      window.open("/#/subscriptions/edit/".concat(id), '_blank');
    },
    fetchLoopSubscriptions: function fetchLoopSubscriptions() {
      var _this2 = this;
      this.subscriptionsList = [];
      if (this.loop.metadata && this.loop.metadata.subscriptionId) {
        var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
        if (!token) return;
        this.subscriptionsLoading = true;
        var subId = this.loop.metadata.subscriptionId;
        (0, _subscriptions.getSubscriptionById)(token, subId).then(function (response) {
          if (response.data && response.data.title) {
            if (!_this2.subscriptionsList.some(function (s) {
              return s.id === subId;
            })) {
              _this2.subscriptionsList.push({
                id: subId,
                title: response.data.title
              });
            }
          }
        }).catch(function (error) {
          (0, _log.showDebugLog)('LoopGeninfo-getSubscriptionById-error', error);
          if (!_this2.subscriptionsList.some(function (s) {
            return s.id === subId;
          })) {
            _this2.subscriptionsList.push({
              id: subId,
              title: 'Subscription: ' + subId
            });
          }
        }).finally(function () {
          _this2.subscriptionsLoading = false;
        });
      }
    },
    prefillFeedbackLink: function prefillFeedbackLink() {
      this.loop.feedbackUrl = "https://otr.link/".concat(this.loop.internal.opportunityNumber);
    },
    passBackGenInfo: function passBackGenInfo(myLoop) {
      console.info(myLoop);
      this.$emit('updateParentGenInfo', myLoop);
    },
    openResourceDialog: function openResourceDialog(type) {
      this.dialogResourceVisible = true;
      this.resourceQuery.type = type;
      this.getResources();
    },
    getResources: function getResources() {
      var _this3 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _resource.fetchList)(token, this.resourceQuery).then(function (response) {
        var data = response.data;
        _this3.resourceOptions = data.rows;
        _this3.tableLoading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('Resource-API-response', error);
        _this3.tableLoading = false;
        displayPopupMessage(error, 'error');
      });
    },
    addResourceInStage: function addResourceInStage(id, title) {
      this.loop.welcomeBox.resource = id;
      this.loop.welcomeBox.resourceTitle = title;
      this.dialogResourceVisible = false;
    },
    clearReplayResource: function clearReplayResource() {
      this.loop.welcomeBox.resource = '';
      this.loop.welcomeBox.resourceTitle = '';
      this.$forceUpdate();
    },
    openContactDialog: function openContactDialog() {
      this.dialogContactVisible = true;
      this.getList();
    },
    getList: function getList() {
      var _this4 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _user.getUserList)(token, this.contactQuery).then(function (response) {
        var data = response.data;
        _this4.userList = data.rows;
        _this4.tableLoading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('GetUserList-api-error', error);
        _this4.tableLoading = false;
        displayPopupMessage(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
      });
    },
    addContactInStage: function addContactInStage(userinfo) {
      this.loop.welcomeBox.coachUuid = userinfo.id;
      this.loop.welcomeBox.coachUgivenName = userinfo.givenName + ' ' + userinfo.familyName;
      this.dialogContactVisible = false;
    },
    clearContactResource: function clearContactResource() {
      this.loop.welcomeBox.coachUuid = null;
      this.loop.welcomeBox.coachUgivenName = '';
      this.$forceUpdate();
    },
    showUTCDate: function showUTCDate(utcDate) {
      // 'YYYY-MM-DD HH:mm:ss [GMT]Z[ (]z[)]'
      // 'YYYY-MM-DD HH:mm:ss (zZ)'
      return (0, _momentTimezone.default)(utcDate).utc().format('YYYY-MM-DD HH:mm:ss (z+0)');
    }
  }
};